import { type MemberFilters } from '../models/member';

// Unscoped: roles are global, not per game/sandbox.
export const rolesQueryKey = {
  all: ['roles'] as const,
  detail: (id: string) => [...rolesQueryKey.all, id],
};

// Memberships are per game: the scope leads the key, so invalidating a game
// prunes everything under it — including every filtered page, since `all` is a
// prefix of `list`.
export const membersQueryKey = {
  all: (gameCode: string) => [gameCode, 'members'] as const,
  list: (gameCode: string, filters?: MemberFilters) => [
    ...membersQueryKey.all(gameCode),
    'list',
    { filters },
  ],
};
